<template>
  <div>
    <div class="common flex-between van-hairline--bottom">
      <span>社区营业状态</span>
      <span
        class="set-switch"
        :class="{'set-switch-anim': checked }"
        @click="switchState"
      ></span>
    </div>
    <div class="common flex-between van-hairline--bottom">
      <span>悦买店长协议</span>
      <van-icon
        name="arrow"
        color="#999999"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: true,
    }
  },
  methods: {
    switchState() {
      if (this.checked) {
        this.$dialog.alert({
          message: "操作后社区用户将不能下单哦",
          confirmButtonText: "确定",
          confirmButtonColor: "#1D1D1D",
          cancelButtonText: "取消",
          cancelButtonColor: "#1993FF",
          showCancelButton: true,
        })
          .then(() => {
            this.checked = false;
          });
      } else {
        this.checked = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.common {
  height: 50px;
  padding: 0 15px;
  font-size: 15px;
  i {
    font-size: 20px;
  }
}
.set-switch {
  width: 70px;
  height: 27px;
  position: relative;
  border: 1px solid #ff1310;
  border-radius: 15px;
  background-clip: content-box;
  display: inline-block;
  -webkit-appearance: none;
  user-select: none;
  outline: none;
  box-sizing: border-box;
}
.set-switch:before {
  content: "";
  width: 23px;
  height: 23px;
  position: absolute;
  top: 1px;
  left: 2px;
  border-radius: 15px;
  background-color: #fff;
  border: 1px solid #ff1310;
  box-sizing: border-box;
  transition: left 0.3s;
}
.set-switch:after {
  content: "休息";
  position: absolute;
  top: 50%;
  right: 11px;
  font-size: 15px;
  font-weight: 800;
  color: #ff1310;
  transform: translateY(-50%);
}
.set-switch-anim {
  background: linear-gradient(90deg, #fb6a4a 0%, #ff0808 100%);
}
.set-switch-anim:before {
  left: 43px;
}
.set-switch-anim:after {
  content: "营业";
  position: absolute;
  top: 50%;
  left: 11px;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
  transform: translateY(-50%);
}
</style>